<template>
  <v-dialog
    :model-value="modelValue"
    max-width="540"
    persistent
    data-testid="publish-without-preview-dialog"
    @update:model-value="(value: boolean) => emit('update:modelValue', value)"
  >
    <v-card>
      <v-card-title class="text-h6">Publish without preview?</v-card-title>
      <v-card-text>
        <p class="mb-2">You have unpublished changes that have not been previewed.</p>
        <p>
          Publish Preview helps catch missing fields, listing rule changes, and inventory visibility
          changes before publishing.
        </p>
        <v-alert
          v-if="status === 'stale'"
          type="warning"
          variant="tonal"
          density="comfortable"
          class="mt-3"
        >
          The most recent preview is out of date because your current changes were updated since it
          ran.
        </v-alert>
        <v-alert
          v-else-if="status === 'failed'"
          type="error"
          variant="tonal"
          density="comfortable"
          class="mt-3"
        >
          The most recent preview failed and was not validated.
        </v-alert>
        <v-alert
          v-else-if="status === 'processing'"
          type="info"
          variant="tonal"
          density="comfortable"
          class="mt-3"
        >
          A Publish Preview is still processing. You can wait for it to finish or publish anyway.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn variant="text" @click="emit('cancel')">Cancel</v-btn>
        <v-spacer />
        <v-btn variant="outlined" color="primary" @click="emit('runPreview')"> Run Preview </v-btn>
        <v-btn variant="flat" color="warning" @click="emit('publishAnyway')">
          Publish Anyway
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import type { PreviewStatus } from '@/stores/usePublishPreviewStore'

defineProps<{
  modelValue: boolean
  status: PreviewStatus
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
  (event: 'cancel'): void
  (event: 'runPreview'): void
  (event: 'publishAnyway'): void
}>()
</script>
